<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="6" xl="4">
                  <BaseSelect
                    :options="levelSelect.options"
                    :data="levelSelect.data"
                    ref="levelSelect">
                  </BaseSelect>
                  <BaseSelect v-show="levelSelect.data.model != 1"
                              :options="categorySelect.options"
                              :data="categorySelect.data"
                              ref="categorySelect">
                  </BaseSelect>
                  <BaseInput
                    :options="codeInput.options"
                    :data="codeInput.data"
                  />
                  <BaseInput
                    :options="nameInput.options"
                    :data="nameInput.data"
                  />
                  <BaseSelect
                    :options="isActiveSelect.options"
                    :data="isActiveSelect.data"
                    ref="isActive">
                  </BaseSelect>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData"
                >
                  <i class="fa fa-refresh"></i> Cập nhật
                </CButton
                >
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.push('/category-management/managed-categories')"
                ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";

export default {
  name: "CategoryUpdate",
  components: {BaseSelect, BaseInput, BaseLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      idField: {
        data: {
          model: that.$route.params.id,
          name: "id"
        }
      },
      levelSelect: {
        options: {
          filter: false,
          label: 'Cấp danh mục',
        },
        data: {
          name: "level",
          items: [
            {key: "1", value: "Level 1"},
            {key: "2", value: "Level 2"},
            {key: "3", value: "Level 3"},
          ],
          model: '',
        }
      },
      categorySelect: {
        options: {
          'keyField': 'id',
          'valueField': 'name',
          label: "Danh mục",
          selectAllText: 'Chọn danh mục',
          lazyLoad: true,
        },
        data: {
          model: '',
          name: 'parentId',
          items: [],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.categorySelect.data.model;
              let dataLevel = that.levelSelect.data.model;
              this.isValid = true;
              if (dataLevel != 1) {
                if (value === "" || value === null) {
                  this.isValid = false;
                  this.errorMessage = "Mã danh mục không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
              }
              return this.isValid;
            }
          }
        }
      },
      codeInput: {
        options: {
          label: "Mã danh mục *",
          placeholder: "Mã danh mục",
          type: "text",
          maxLength : 100
        },
        data: {
          name: "code",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.codeInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Mã danh mục không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      nameInput: {
        options: {
          label: "Tên danh mục *",
          placeholder: "Tên danh mục",
          type: "text",
          maxLength : 200
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Tên danh mục không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      isActiveSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: 'active',
          model: '',
          items: [
            {key: "true", value: "Hoạt động"},
            {key: "false", value: "Không hoạt động"},
          ],
        }
      }
    };
  },
  methods: {
    loadDataCategory: function (value) {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/category/findByLevel",
        dataSubmit: function () {
          return {level: value - 1}
        },
        isJsonContentType: false,
        successCallback: function (response) {
          that.categorySelect.data.items = response.data.data;
          setTimeout(function () {
            that.categorySelect.data.model = that.dataCache.parentId;
          }, 200)
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    getData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/category/findById",
        dataSubmit: function () {
          return {id: that.idField.data.model}
        },
        isJsonContentType: false,
        successCallback: function (response) {
          let dataRes = response.data.data;
          // if (dataRes.active == true) {
          //   dataRes.active = 1;
          // } else {
          //   dataRes.active = 0;
          // }
          dataRes.active = dataRes.active + "";
          that.dataCache = that.$helper.setupDataResponse(that.$data, dataRes);
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/category/updateCategory",
        dataValid: function () {
          return that.dataCache;
        },
        validFalseCallback: function () {
          that.showWarningMsg({message: "Xin thay đổi thông tin trước khi cập nhật"});
        },
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Cập nhật danh mục thành công"});
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.getData();
  },
  watch: {
    'levelSelect.data.model': function (val) {
      this.loadDataCategory(val);
    }
  }
};
</script>
